import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import { RegistrationProvider } from './contexts/RegistrationContext';

// Pages
import Home from './pages/Home';
import Event from './pages/Event';
import Info from './pages/Info';
import Participate from './pages/Participate';
import Staff from './pages/Staff';
import Intensives from './pages/Intensives';
import Competitions from './pages/Competitions';
import Schedule from './pages/Schedule';
import Venue from './pages/Venue';
import PracticalInfo from './pages/PracticalInfo';
import Registration from './pages/Registration';
import PassReservation from './pages/PassReservation';
import Streaming from './pages/Streaming';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import Admin from './pages/Admin';
import Maintenance from './pages/Maintenance';

// Auth and User Pages
import Login from './pages/Login';
import Register from './pages/Register';
import UserDashboard from './pages/UserDashboard';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PassPurchase from './pages/PassPurchase';
import PasswordChange from './pages/PasswordChange';

// Admin Pages
import AdminDashboard from './pages/admin/AdminDashboard';
import UsersManagement from './pages/admin/UsersManagement';
import RegistrationsManagement from './pages/admin/RegistrationsManagement';
import CompetitionsManagement from './pages/admin/CompetitionsManagement';
import WorkshopsManagement from './pages/admin/WorkshopsManagement';
import PassManagement from './pages/admin/PassManagement';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

function App() {
  // Check if we're in maintenance mode
  const isMaintenanceMode = true; // Set to true to enable maintenance mode

  return (
    <LanguageProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <RegistrationProvider>
            <Router>
              <ScrollToTop />
          {isMaintenanceMode ? (
            // Maintenance mode - only show the maintenance page
            <Routes>
              <Route path="*" element={<Maintenance />} />
            </Routes>
          ) : (
            // Normal mode - show all routes with navigation and footer
            <>
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/evenement" element={<Event />} />
                <Route path="/participer" element={<Participate />} />
                <Route path="/info" element={<Info />} />
                <Route path="/staff" element={<Staff />} />
                <Route path="/intensives" element={<Intensives />} />
                <Route path="/competitions" element={<Competitions />} />
                <Route path="/schedule" element={<Schedule />} />
                <Route path="/venue" element={<Venue />} />
                <Route path="/infos-pratiques" element={<PracticalInfo />} />
                <Route path="/registration" element={<Registration />} />
                <Route path="/reservation-pass" element={<PassReservation />} />
                <Route path="/streaming" element={<Streaming />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/admin" element={<Admin />} />
                
                {/* Admin Routes */}
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/admin/users" element={<UsersManagement />} />
                <Route path="/admin/registrations" element={<RegistrationsManagement />} />
                <Route path="/admin/competitions" element={<CompetitionsManagement />} />
                <Route path="/admin/workshops" element={<WorkshopsManagement />} />
                <Route path="/admin/passes" element={<PassManagement />} />
                
                {/* Auth Routes */}
                <Route path="/connexion" element={<Login />} />
                <Route path="/inscription" element={<Register />} />
                <Route path="/mon-compte" element={<UserDashboard />} />
                <Route path="/verifier-email" element={<VerifyEmail />} />
                <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
                <Route path="/reinitialiser-mot-de-passe" element={<ResetPassword />} />
                <Route path="/mot-de-passe" element={<PasswordChange />} />
                
                {/* Pass Routes */}
                <Route path="/passes" element={<PassPurchase />} />
              </Routes>
              <Footer />
            </>
          )}
            </Router>
          </RegistrationProvider>
        </AuthProvider>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
